

import {
  Box, Button, Container, Paper, Table, TableBody, TableContainer, TableHead,
  Typography
} from "@mui/material";
import React, { useEffect, useState, useRef, useMemo } from "react";
import { SearchOutlined } from "@mui/icons-material";
import { NavLink } from "react-router-dom";
import styles from "../../../styles.module.css";
import { useDispatch, useSelector } from "react-redux";
import {
  ActionMsg,
  AddButton,
  Breadcrumb,
  CustomePopover,
  DeleteDialog,
  ExcelDownload,
  HandleCloseSnackbar,
  HandleSort,
  SearchInput,
  StyledTableCell,
  StyledTableRow,
  useMessageHandler, BootstrapDialog, BootstrapDialogTitle
} from "../../reusableComponent/Reusables";
import { addImportCustomer, editDeleteCustomer, getCustomerList } from "../../../actions/actions";
import UploadFileTwoToneIcon from '@mui/icons-material/UploadFileTwoTone';
import HeaderSection from "../../reusableComponent/HeaderSection";
import customerMasterService from "../../../services/masters/customerMaster.Service";
import ReusableSnackbar from "../../reusableComponent/ReusableSnackbar";
import CustomPagination from "../../reusableComponent/CustomPagination";
import accountManagerMasterService from "../../../services/masters/accountManagerMaster.Service";
import * as XLSX from "xlsx";


const CustomerList = () => {
  const dispatch = useDispatch();
  const totalCount = useSelector(state => state.customer.total_count || 0);
  const defaultRowsPerPage = useSelector(state => state.customer.rows_per_page || 15);
  const respMsgState = useSelector((state) => state.customer.message);

  

  const [rows, setRows] = useState([]);
  const [isDelete, setIsDelete] = useState(false);
  const [deleteInfo, setDeleteInfo] = useState();
  const [sortBy, setSortBy] = useState(null);
  const [open, setOpen] = useState(false);
  const [openOption, setOpenOption] = useState("");
  const [info, setInfo] = useState({});
  const [searchKey, setSearchKey] = useState("");
  const [successMessage, setSuccessMessage] = useState(null);
  const [fileUploadError, setFileUploadError] = useState(""); // Added for file upload errors
  const [account_manager, setAccountManager] = useState([]);
  const [total_count,setTotalCount]=useState(null)
  useEffect(() => {
    setTotalCount(rows[0]?.totalCount);
  }, [rows]);

  const [controller, setController] = useState({
    page: 0,
    rowsPerPage: defaultRowsPerPage
  });

  useEffect(() => {
    setController(prev => ({
      ...prev,
      rowsPerPage: defaultRowsPerPage,
      page: 0,
    }));
  }, [defaultRowsPerPage]);

  const fields = ["cust_name", "city","state","from_depot"];
  const labels = ["Customer Name", "City","State","From Depot"];

  const fetchData = async () => {
    try {
      const params = {
        page: controller.page,
        size: controller.rowsPerPage,
        searchKey: searchKey,
      };
      const response = await customerMasterService.getCustomerList(params);
      setRows(response);
    } catch (error) {
      
    }
  };

  useEffect(() => {
    fetchData();
  }, [controller, searchKey]); 

  useEffect(() => {
    async function fetchAccountManagers() {
      try {
        const accountManagerData = await accountManagerMasterService.getAccountManagerList({
          page: 0,
          size: 10,
          searchKey: "",
        });
        setAccountManager(accountManagerData);
      } catch (error) {
        console.error("", error);
        setSuccessMessage("");
      }
    }
    fetchAccountManagers();
  }, []);

  const handleChangePage = (event, newPage) => {
    setController({
      ...controller,
      page: newPage,
    });
  };

  const handleChangeRowsPerPage = (event) => {
    setController({
      ...controller,
      rowsPerPage: parseInt(event.target.value, 10),
      page: 0,
    });
  };

 const handleSearch = async (e) => {
  const searchValue = e.target.value;
  setSearchKey(searchValue);

  setController(prev => ({
    ...prev,
    page: 0
  }));

  const params = {
    page: 0,
    size: controller.rowsPerPage,
    searchKey: searchValue,
  };

  try {
    await fetchData(params);
  } catch (error) {
    console.error("Error in handleSearch:", error);
    setSuccessMessage("Error searching data");
  }
};


  const deleteRecord = async (id) => {
    try {
      await customerMasterService.editDeleteCustomer({
        cust_id: id,
        changedUpdatedValue: "delete"
      });
      setIsDelete(false);
      fetchData();
      setSuccessMessage("Record deleted successfully");
    } catch (error) {
      setSuccessMessage("Error deleting record");
    }
  };

  const handleDelete = (row) => {
    setIsDelete(true);
    setDeleteInfo(row);
  };

  const handleClose = (event, reason) => {
    setIsDelete(false);
    setDeleteInfo(null);
    setOpen(false);
  };

  const handleDetails = (detail) => {
    setInfo(detail);
    setOpen(true);
    setOpenOption("Details");
  };

  const fileInputRef = useRef(null);
  const handleUpload = () => {
    fileInputRef.current.click();
  };

  const handleFileChange = async (e) => {
    const file = e.target.files[0];
    setFileUploadError("");
    setSuccessMessage("");
    if (!file) return;

    const fileExtension = file.name.split(".").pop().toLowerCase();
    if (!["xlsx", "xls", "csv"].includes(fileExtension)) {
      setFileUploadError("Please upload a valid Excel file (.xlsx, .xls, or .csv)");
      return;
    }

    const reader = new FileReader();
    reader.onload = async (event) => {
      try {
        const data = new Uint8Array(event.target.result);
        const workbook = XLSX.read(data, { type: "array" });
        const worksheet = workbook.Sheets[workbook.SheetNames[0]];
        const jsonData = XLSX.utils.sheet_to_json(worksheet);

        if (jsonData.length === 0) {
          setFileUploadError("The uploaded file contains no data.");
          return;
        }

        const processedData = jsonData.map((row, index) => ({
          rowIndex: index + 2,
          cust_name: row["Customer Name"] ? String(row["Customer Name"]).trim() : "",
          city: row["City"] ? String(row["City"]).trim() : "",
          state: row["State"] ? String(row["State"]).trim() : "",
          contact_person: row["Contact Person"] ? String(row["Contact Person"]).trim() : "",
          contact_no: row["Contact No"] ? String(row["Contact No"]).trim() : "",
          sales_officer_id: row["Sales Officer ID"] ? String(row["Sales Officer ID"]).trim() : "",
        }));

        try {
          const response = await dispatch(addImportCustomer({ customers: processedData.map(({ rowIndex, ...data }) => data) })).unwrap();
          setSuccessMessage(
            response.skipped > 0
              ? `Imported ${response.imported} records. Skipped ${response.skipped} duplicates.`
              : `Successfully imported ${processedData.length} customer records.`
          );
          fetchData();
        } catch (error) {
          setFileUploadError(error.message || "Failed to process the file. Please check the data.");
        }
      } catch (error) {
        setFileUploadError("Failed to parse the file. Please ensure it is a valid Excel/CSV file.");
      }
      e.target.value = null;
    };
    reader.readAsArrayBuffer(file);
  };

  const sortedRows = useMemo(() => {
    return [...rows].sort((a, b) => new Date(b.entry_date) - new Date(a.entry_date));
  }, [rows]);

  const effectiveTotalCount = total_count > 0 ? total_count : rows.length > 0 ? rows.length : 0;
  const startRecord = effectiveTotalCount === 0 ? 0 : controller.page * controller.rowsPerPage + 1;
  const endRecord = effectiveTotalCount === 0 ? 0 : Math.min((controller.page + 1) * controller.rowsPerPage, effectiveTotalCount);
  const paginationInfo = `${startRecord}-${endRecord} of ${total_count}`;

  const salesOfficerMap = useMemo(() => {
    const map = {};
    account_manager.forEach((officer) => {
      map[officer.sales_officer_id] = officer.sales_officer_name;
    });
    return map;
  }, [account_manager]);

  return (
    <Box className={`${styles.cts_page}`} sx={{ padding: '0px !important', margin: '0px !important' }}>
      <Box className={`${styles.body}`}>
        <Breadcrumb routeSegments={[{ name: "Customer List" }]} />
        <HeaderSection
          title="CUSTOMER LIST"
          addNewPath="/masters/add-customer"
          searchKey={searchKey}
          handleSearch={handleSearch}
          sortedRows={sortedRows}
          fields={fields}
          labels={labels}
          filename="Customer List"
          paginationInfo={paginationInfo}
          controller={controller}
          handleChangePage={handleChangePage}
          showUploadButton={true}
          onUploadClick={handleUpload}
        />
        <input
          type="file"
          ref={fileInputRef}
          style={{ display: "none" }}
          accept=".xlsx,.xls,.csv"
          onChange={handleFileChange}
        />
       <Paper sx={{ width: '100%',}}> 
        <TableContainer component={Paper} className={`${styles.list_tbl_container}`}>
          <Table size="small" stickyHeader>
            <TableHead>
              <StyledTableRow>
                <StyledTableCell
                  align="left"
                  className={`${styles.table_head}`}
                  onClick={() => HandleSort("cust_name", sortBy, setSortBy, rows)}
                  sx={{ width: '40%' }}
                >
                  Customer Name
                  <span className={`${styles.sort_icon}`}>
                    {sortBy === "cust_name" ? "▲" : "▼"}
                  </span>
                </StyledTableCell>
                <StyledTableCell
                  align="left"
                  className={`${styles.table_head}`}
                  onClick={() => HandleSort("city", sortBy, setSortBy, rows)}
                >
                  City
                  <span className={`${styles.sort_icon}`}>
                    {sortBy === "city" ? "▲" : "▼"}
                  </span>
                </StyledTableCell>
                <StyledTableCell
                  align="left"
                  className={`${styles.table_head}`}
                  onClick={() => HandleSort("state", sortBy, setSortBy, rows)}
                >
                  State
                  <span className={`${styles.sort_icon}`}>
                    {sortBy === "state" ? "▲" : "▼"}
                  </span>
                </StyledTableCell>
               
               
                

                <StyledTableCell
                  align="left"
                  className={`${styles.table_head}`}
                  onClick={() => HandleSort("account_manager", sortBy, setSortBy, rows)}
                >
                From Depot
                  <span className={`${styles.sort_icon}`}>
                    {sortBy === "sales_officer" ? "▲" : "▼"}
                  </span>
                </StyledTableCell>
                <StyledTableCell align="center" className={`${styles.table_head}`}>
                  Action
                </StyledTableCell>
              </StyledTableRow>
            </TableHead>
            <TableBody sx={{ backgroundColor: '#fff' }}>
              {Array.isArray(rows) &&
                rows.map((row) => (
                  <StyledTableRow
                    key={row.cust_id} 
                    sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                  >
                    <StyledTableCell align="left" className={`${styles.list_table_body}`}>
                      {row.cust_name}
                    </StyledTableCell>
                    <StyledTableCell align="left" className={`${styles.list_table_body}`}>
                      {row.city}
                    </StyledTableCell>
                    <StyledTableCell align="left" className={`${styles.list_table_body}`}>
                      {row.state}
                    </StyledTableCell>
                    

                     <StyledTableCell align="left" className={`${styles.list_table_body}`}>
                      {row.depot_name|| "N/A"}
                    </StyledTableCell>
                    <StyledTableCell align="center">
                      <CustomePopover
                        row={row}
                        handleDelete={false}
                        linkTo="/masters/add-customer"
                        handlePrint={false}
                        handleCancel={false}
                      />
                    </StyledTableCell>
                  </StyledTableRow>
                ))}
            </TableBody>
          </Table>

        </TableContainer>
         <CustomPagination
                      page={controller.page}
                      rowsPerPage={controller.rowsPerPage}
                      totalCount={total_count || 0}
                      onPageChange={(newPage) => handleChangePage(null, newPage)}
                    />

       </Paper> 
        <DeleteDialog
          open={isDelete}
          handleClose={handleClose}
          deleteInfo={deleteInfo}
          deleteRecord={deleteRecord}
          deleteID={deleteInfo?.cust_id || null}
          displayName={deleteInfo?.cust_code || ""}
        />
        <ReusableSnackbar
          open={!!successMessage || !!fileUploadError}
          onClose={(event, reason) => {
            if (reason !== 'clickaway') {
              HandleCloseSnackbar(event, reason, setSuccessMessage);
              setFileUploadError("");
            }
          }}
          message={successMessage || fileUploadError}
          autoHideDuration={2000}
          vertical="top"
          horizontal="right"
        />
        <BootstrapDialog
          PaperProps={{
            sx: {
              minWidth: openOption === "Details" ? "95%" : "60%",
              maxHeight: "90%",
            },
          }}
          onClose={handleClose}
          open={open}
        >
          <BootstrapDialogTitle
            id="customized-dialog-title"
            onClose={handleClose}
          >
            {openOption === "Details" ? "View Customer Details" : ""}
          </BootstrapDialogTitle>
        </BootstrapDialog>
      </Box>
    </Box>
  );
};

export default CustomerList;